type Input = {
  canTransition: boolean;
  handleTransitionEnd: (event?: TransitionEvent) => void;
  innerElement: HTMLDivElement;
  panelElement: HTMLDivElement;
};

export const setOpenAnimationStyles = (input: Input) => {
  const { canTransition, handleTransitionEnd, innerElement, panelElement } =
    input;

  panelElement.hidden = false;
  panelElement.style.visibility = "hidden";
  panelElement.style.opacity = "0";
  panelElement.style.height = "0";

  requestAnimationFrame(() => {
    const target = innerElement.scrollHeight;

    if (!canTransition) {
      panelElement.style.height = "auto";
      panelElement.style.opacity = "1";
      panelElement.style.visibility = "";
      return;
    }

    requestAnimationFrame(() => {
      panelElement.addEventListener("transitionend", handleTransitionEnd, {
        once: true,
      });
      panelElement.style.visibility = "";
      panelElement.style.opacity = "1";
      panelElement.getBoundingClientRect();
      panelElement.style.height = `${target}px`;
    });
  });
};
